/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'power',
    quality: 0.3,
    mana: 1,
    strength: 1,
    damageMod: 0.05
}